import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import Switch from "@material-ui/core/Switch"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"
import {
  toggleAddClientCompanyDialog,
  toggleDeleteClientDialog,
  createClientCompany,
  updateClientCompany,
  deleteClient,
  _setEditClient,
  getClientCompanies,
  _setEditClientCompany,
  setCreatedClientCompany,
} from "../../actions/clients"

import { isEmpty, pickBy } from "lodash"
import update from "immutability-helper"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"

import FormHelperText from "@material-ui/core/FormHelperText"
import Grid from "@material-ui/core/Grid"
import { openSnackBar } from "../../actions/snack-bar"
import IconButton from "@material-ui/core/IconButton"
import Checkbox from "@material-ui/core/Checkbox"
import Paper from "@material-ui/core/Paper"

import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"

import TextField from "@material-ui/core/TextField"
import classNames from "classnames"
import Moment from "moment"
import { parseNumber } from "libphonenumber-js"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"
import CircularProgress from "@material-ui/core/CircularProgress"
import { uploadFile } from "../../actions/misc"
import Avatar from "@material-ui/core/Avatar"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import "react-image-gallery/styles/css/image-gallery.css"
import AddressAutoComplete from "../AddressAutoComplete"

import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import InputMask from "react-input-mask"
import { pick } from "lodash"

const locationVal = e => (e ? e + " " : "")

const defaultState = {
  client: {
    name: "",
    email: "",
    location: "",
    ein_ssn: "",
    logo_image: null,
    check_payment: false,
  },
  newNote: "",
  savingProfile: false,
  selectedCountry: "US",
  uploadingAvatar: false,
  tempImageData: null,
}
class AddClientCompanyDialog extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
  }
  handleClose = () => {
    this.props.dispatch(toggleAddClientCompanyDialog(false))
    this.props.dispatch(_setEditClientCompany())
  }
  clearState = () => {
    this.setState(defaultState)
  }
  setUpForm = () => {
    const { client } = this.props
    const form = document.getElementById("edit-form-client-company")
    const inputs = form.querySelectorAll("input, textarea")
    let newState = update(this.state, {})
    if (!newState.form) {
      newState.form = {}
    }
    for (let i = 0; i < inputs.length; ++i) {
      newState.form[inputs[i].name] = { validity: inputs[i].validity }
    }
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
    if (!isEmpty(client)) {
      this.setState({
        client: {
          name: client.name,
          location: client.location,
          email: client.email,
          logo_image: client.logo_image,
          check_payment: Boolean(client.check_payment),
        },
      })
    }
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity



    let newState = update(this.state, {
      client: {
        [fieldName]: { $set: value },
      },
      form: {
        [fieldName]: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleChangeSwitch = event => {
    let newState = update(this.state, {
      client: {
        check_payment: { $set: event.target.checked },
      },
    })
    this.setState(newState)
  }

  handlePhoneChange = value => {
    let validity = document.getElementById("phoneInput").validity
    if (value) {
      validity.phone = !isEmpty(parseNumber(value, this.state.selectedCountry))
    } else {
      validity.phone = false
    }

    let newState = update(this.state, {
      client: {
        phone: { $set: value ? value : "" },
      },
      form: {
        phone: {
          validity: { $set: validity },
        },
      },
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleCountryChange = country => {
    this.setState({ selectedCountry: country })
  }
  handleInputBlur = e => {
    const fieldName = e.target.name

    let newState = update(this.state, {
      form: {
        [fieldName]: {
          touched: { $set: true },
        },
      },
    })
    this.setState(newState)
  }
  handlePhoneBlur = e => {
    this.setState(
      update(this.state, {
        form: {
          phone: {
            touched: { $set: true },
          },
        },
      })
    )
  }
  fieldIsValid = inputName => {
    if (!isEmpty(this.state.form)) {
      if (this.state.form[inputName].touched) {
        if (inputName === "phone") {
          return (
            this.state.form[inputName].validity.valid &&
            this.state.form[inputName].validity.phone
          )
        } else {
          return this.state.form[inputName].validity.valid
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  pushNote = () => {
    this.setState(
      update(this.state, {
        client: {
          notes: {
            $push: [
              {
                note: this.state.newNote,
              },
            ],
          },
        },
        newNote: {
          $set: "",
        },
      })
    )
  }


  submit = () => {
    const { client, companiesList } = this.props
    const { tempImageData } = this.state
    this.setState({
      savingProfile: true,
    })
    let clientCheck = companiesList.find(
      c =>
        !isEmpty(c.email) &&
        !isEmpty(this.state.client.email) &&
        c.email.toLowerCase() === this.state.client.email.toLowerCase()
    )

    const data = pickBy(this.state.client, val => {
      return !isEmpty(val) || typeof val === "boolean"
    })
    // data.gtt = this.state.client.gtt == true ? 1 : 0
    // data.ad = this.state.client.ad == true ? 1 : 0
    // data.notes = this.state.newNote

    if (!isEmpty(client)) {
      data.logo_image = tempImageData ? tempImageData : client.logo_image
    }

    if (!isEmpty(client) && client.id) {
      this.props
        .dispatch(
          updateClientCompany(
            {
              ...data,
            },
            client.id
          )
        )
        .then(res => {

          this.props.dispatch(
            openSnackBar({
              message: res.message,
            })
          )
          if (this.props.origin && this.props.origin === "create_shoot") {
            this.props.onSaveUser(res.data)
            this.props.dispatch(setCreatedClientCompany(res.data))
          }
          this.props.dispatch(getClientCompanies()).then(() => {
            this.setState({
              savingProfile: false,
            })
            this.props.dispatch(toggleAddClientCompanyDialog(false))
            this.props.dispatch(_setEditClientCompany())
          }).catch((err) => {
            this.setState({
              savingProfile: false,
            })
            this.props.dispatch(toggleAddClientCompanyDialog(false))
            this.props.dispatch(_setEditClientCompany())
          })

        })


        .catch(err => {
          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
          return
        })
    } else {
      if (clientCheck) {
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "Email Already Exists",
          })
        )
        return
      }
      this.props
        .dispatch(
          createClientCompany({
            ...data,
          })
        )
        .then(res => {
          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: res.message,
            })
          )
          if (this.props.origin && this.props.origin === "create_shoot") {
            this.props.onSaveUser(res.data)
            this.props.dispatch(setCreatedClientCompany(res.data))
          }
          this.props.dispatch(getClientCompanies())
          this.props.dispatch(toggleAddClientCompanyDialog(false))
        })
        .catch(err => {

          this.setState({
            savingProfile: false,
          })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
          return
        })
    }
  }

  createCompanyFirst = async file => {
    const { client, companiesList } = this.props

    this.setState({
      savingProfile: true,
    })
    let clientCheck = companiesList.find(
      c =>
        !isEmpty(c.email) &&
        !isEmpty(this.state.client.email) &&
        c.email.toLowerCase() === this.state.client.email.toLowerCase()
    )

    const data = pickBy(this.state.client, val => !isEmpty(val))

    if (clientCheck) {
      this.setState({
        savingProfile: false,
      })
      this.props.dispatch(
        openSnackBar({
          message: "Email Already Exists",
        })
      )
      return
    }

    this.props
      .dispatch(
        createClientCompany({
          ...data,
        })
      )
      .then(res => {
        this.setState({
          savingProfile: false,
        })
        // this.props.dispatch(
        //   openSnackBar({
        //     message: res.message,
        //   })
        // )
        // this.props.dispatch(getClientCompanies())
        this.props.dispatch(_setEditClientCompany(res.data))
        this.props
          .dispatch(
            uploadFile(file, `client_companies/${res.data.id}/profile_images`)
          )
          .then(image => {
            if (!isEmpty(res.data) && res.data.id) {
              this.props
                .dispatch(
                  updateClientCompany(
                    {
                      logo_image: JSON.stringify(image),
                    },
                    res.data.id
                  )
                )
                .then(() => {
                  this.props.client.logo_image = JSON.stringify(image)
                  this.setState({ tempImageData: JSON.stringify(image) })

                  this.props.dispatch(_setEditClientCompany(this.props.client))
                  this.setState({ uploadingAvatar: false })
                  document.getElementById("logoImage").value = ""
                })
                .catch(err => {
                  this.props.dispatch(
                    openSnackBar({
                      message: "There was an error saving avatar",
                    })
                  )
                  this.setState({ uploadingAvatar: false })
                  document.getElementById("logoImage").value = ""
                })
            } else {

              this.props.client.logo_image = JSON.stringify(image)
              this.setState({ tempImageData: JSON.stringify(image) })
              // this.props.dispatch(_setEditClient(this.props.client))
              this.props.dispatch(_setEditClientCompany(this.props.client))
              // dynamic update client without closing dialog
              this.setState({ uploadingAvatar: false })
              document.getElementById("logoImage").value = ""


            }
          })
          .catch(err => {
            this.setState({ uploadingAvatar: false })
            document.getElementById("logoImage").value = ""
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving avatar",
              })
            )
          })
      })
      .catch(err => {
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "There was an unknown error",
          })
        )
        return
      })
  }

  avatarChanged = async e => {
    const { client } = this.props

    const file = e.target.files[0]
    this.setState({ uploadingAvatar: true })
    let clientId = client && client.id ? client.id : null
    if (!clientId) {
      await this.createCompanyFirst(file)
    } else {
      this.props
        .dispatch(
          uploadFile(
            file,
            `client_companies/${this.props.client.id}/profile_images`
          )
        )
        .then(image => {
          if (!isEmpty(this.props.client) && this.props.client.id) {
            this.props
              .dispatch(
                updateClientCompany(
                  {
                    logo_image: JSON.stringify(image),
                  },
                  this.props.client.id
                )
              )
              .then((res) => {
                this.props.client.logo_image = JSON.stringify(image)
                this.setState({ tempImageData: JSON.stringify(image) })
                this.props.dispatch(_setEditClientCompany(this.props.client))
                // this.props.dispatch(_setEditClient(this.props.client))
                // dynamic update client without closing dialog
                this.setState({ uploadingAvatar: false })
                document.getElementById("logoImage").value = ""
              })
              .catch(err => {
                this.props.dispatch(
                  openSnackBar({
                    message: "There was an error saving avatar",
                  })
                )
                this.setState({ uploadingAvatar: false })
                document.getElementById("logoImage").value = ""
              })
          } else {
            this.props.client.logo_image = JSON.stringify(image)
            this.setState({ tempImageData: JSON.stringify(image) })
            this.props.dispatch(_setEditClientCompany(this.props.client))
            // this.props.dispatch(_setEditClient(this.props.client))
            // dynamic update client without closing dialog
            this.setState({ uploadingAvatar: false })
            document.getElementById("logoImage").value = ""
          }
        })
        .catch(err => {
          this.setState({ uploadingAvatar: false })
          document.getElementById("logoImage").value = ""
          this.props.dispatch(
            openSnackBar({
              message: "There was an error saving avatar",
            })
          )
        })
    }
  }

  generateAvatar = () => {
    const { client } = this.props
    if (this.props.client && this.props.client.logo_image) {
      return (
        <img
          className={this.props.classes.avatarImage}
          src={`https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,g_face:auto,z_0.7,h_400,w_400,fl_lossy,f_auto/v${JSON.parse(this.props.client.logo_image).version}/${JSON.parse(this.props.client.logo_image).public_id
            }.${JSON.parse(this.props.client.logo_image).format}`}
          alt={this.props.client.name}
        />
      )
    } else {
      return (
        <Avatar className={this.props.classes.avatar}>
          {!isEmpty(client) && !isEmpty(client.name)
            ? client.name.charAt(0)
            : ""}
        </Avatar>
      )
    }
  }
  setLocation = data => {
    // this.setState({
    //   client: { location: { $set: JSON.stringify(data) } },
    // })

    let newState = update(this.state, {
      client: {
        location: { $set: JSON.stringify(data) },
      },
    })
    this.setState(newState)
  }

  handelEinChange = e => {
    const { client } = this.props
    let value = parseInt(e.target.value)
    let newState
    if (!isEmpty(client)) {
      newState = update(this.state, {
        client: {
          ein_ssn: { $set: client.is_ein === value ? client.ein_ssn : "" },
          is_ein: { $set: value },
        },
      })
    } else {
      newState = update(this.state, {
        client: { ein_ssn: { $set: "" }, is_ein: { $set: value } },
      })
    }
    this.setState(newState)
  }

  render() {
    const { fullScreen, classes, client } = this.props
    if (client.hasOwnProperty("location")) {
      // console.log("address", JSON.parse(client.location))
      console.log(Object.values(pick(JSON.parse(client.location), ["street_number", "route", "zip", "city", "state", "country"])).toString())
    }

    return (
      <Dialog
        className={classes.profileDialog}
        fullScreen={fullScreen}
        open={this.props.addClientCompanyDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        disableBackdropClick
        PaperProps={{
          classes: {
            root: classes.dialogPaper,
          },
        }}
      >
        <form
          id="edit-form-client-company"
          className={classes.mobileForm}
          noValidate
          autoComplete="off"
        >
          <DialogTitle disableTypography className={classes.dialogTitle}>
            {!isEmpty(client) &&
              client.name && (
                <Typography className={classes.textColor} variant="h6">{`Edit ${client.name
                  }`}</Typography>
              )}
            {(isEmpty(client) || (!isEmpty(client) && !client.id)) && (
              <Typography className={classes.textColor} variant="h6">
                {"New Company"}
              </Typography>
            )}
            <IconButton
              className={classes.closeButton}
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={5} className={classes.backgroundDim}>
                <FormControl fullWidth className={classes.paddingTop}>
                  <InputLabel htmlFor="name">Company Name</InputLabel>
                  <Input
                    type="text"
                    fullWidth
                    name="name"
                    value={this.state.client.name}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="name"
                    autoComplete="nope"
                    inputProps={{
                      required: true,
                    }}
                  />
                </FormControl>

                <FormControl fullWidth className={classes.paddingTop}>
                  <AddressAutoComplete
                    value={
                      // !isEmpty(client) &&
                      //   client.location &&
                      //   Object.keys(JSON.parse(client.location)).length > 0
                      //   ? `${locationVal(
                      //     JSON.parse(client.location).street_number
                      //   )}${locationVal(client.location.route)}${locationVal(
                      //     JSON.parse(client.location).city
                      //   ).replace(" ", ", ")}${locationVal(
                      //     JSON.parse(client.location).state
                      //   )}${locationVal(
                      //     JSON.parse(client.location).zip
                      //   ).replace(" ", "")}`
                      //   : undefined
                      client.hasOwnProperty("location") &&
                      Object.values(pick(JSON.parse(client.location), ["street_number", "route", "city", "state", "zip", "country"])).join(", ")
                    }
                    InputProps={{
                      label: "Address",
                      id: "shoot-location",
                    }}
                    onChange={this.setLocation}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel htmlFor="email">Email *</InputLabel>
                  <Input
                    type="email"
                    fullWidth
                    name="email"
                    value={this.state.client.email}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputBlur}
                    id="email"
                    error={!this.fieldIsValid("email")}
                    autoComplete="nope"
                    inputProps={{
                      required: this.state.selectedCountry !== "US",
                    }}
                  />
                  <FormHelperText error id="email">
                    {!this.fieldIsValid("email") && <span>Enter email</span>}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth className={classes.marginBottom}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.client.check_payment}
                        onChange={this.handleChangeSwitch}
                        name="check_payment"
                      />
                    }
                    label="Pay via check"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={7}>
                <div
                  className={classNames(
                    classes.headlineWrapper,
                    classes.marginTop3
                  )}
                >
                  {!isEmpty(client) && (
                    <Typography variant="h5" className={classes.updateHeadline}>
                      last updated{" "}
                      {Moment(client.updated)
                        // .utc()
                        .from(Moment().subtract(5, "hours"))}
                    </Typography>
                  )}
                </div>
                {this.state.client.name && (
                  <div
                    className={classNames(classes.noteArea, classes.marginTop3)}
                  >
                    <Typography
                      variant="h5"
                      className={classes.addCompanyLogoHeadline}
                    >
                      Add Company Logo*
                    </Typography>
                    <Paper eleation={2} className={classes.avatarPaper}>
                      <div
                        className={classNames(
                          classes.avatarWrapper,
                          classes.imageOverlay
                        )}
                      >
                        {this.state.uploadingAvatar ? (
                          <div className={classes.avatarUploadOverlay}>
                            <CircularProgress
                              color="inherit"
                              className={classes.avatarUploadProgress}
                            />
                          </div>
                        ) : (
                          <label
                            htmlFor="logoImage"
                            className={classes.avatarLabel}
                          >
                            {!this.state.uploadingAvatar && (
                              <div className={classes.addImageOverlay}>
                                <AddPhotoAlternate
                                  className={classes.addPhotoIcon}
                                />
                              </div>
                            )}
                            {this.generateAvatar()}
                            <input
                              type="file"
                              id="logoImage"
                              name="logoImage"
                              className={classes.avatarInput}
                              value={this.state.client.logoImage}
                              onChange={this.avatarChanged}
                            />
                          </label>
                        )}
                      </div>
                    </Paper>
                  </div>
                )}

                <DialogActions className={classes.dialogActions}>
                  <Button
                    variant="text"
                    color="secondary"
                    onClick={this.handleClose}
                  >
                    Close
                  </Button>
                  <LoadingButton
                    color="primary"
                    className={classes.button}
                    buttonclicked={this.submit}
                    working={
                      this.state.savingProfile || this.state.uploadingAvatar
                    }
                    disabled={
                      this.state.client.name === ""
                    }
                    // disabled={
                    //   this.state.client.name === "" ||
                    //   !this.props.client.logo_image
                    // }
                    type="button"
                  >
                    Save
                  </LoadingButton>
                </DialogActions>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    addClientCompanyDialogOpen: state.clients.addClientCompanyDialogOpen,
    user: state.users.editUser,
    client: state.clients.editClientCompany,
    roles: state.misc.roles,
    locations: state.misc.locations,
    activeCompany: state.companies.activeCompany,
    createdClient: state.users.createdClient,
    clientList: state.clients.clients,
    companiesList: state.clients.companiesList,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(AddClientCompanyDialog)
